module.exports = Em.Handlebars.compile("<maintenance-bar-module />\n");